import lxwConstants from "../../config/lexworkplace-constants";

const tenantPlanTypes = lxwConstants.tenantPlanTypes;

export const firmStatusPillConfig = {
	Hidden: {
		style: {
			color: "var(--lw-dark-grey)",
			backgroundColor: "var(--lw-light-grey-c)",
		},
		title: "This firm is hidden from certain admin table views",
	},
	Suspended: {
		style: { backgroundColor: "black" },
		title: "This firm is suspended. All login and API access is blocked.",
	},
};

export function getFirmStatusPillLabel(planType) {
	if (planType === tenantPlanTypes.options.HIDDEN) return "Hidden";
	if (planType === tenantPlanTypes.options.SUSPENDED) return "Suspended";
	return null;
}

export function isTenantSuspended(planType) {
	return planType === tenantPlanTypes.options.SUSPENDED;
}
